import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../../shared/utils/re-base-data';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TrackingService } from '../../services/tracking.service';

@Component({
    selector: 'bdo-minimal-footer',
    templateUrl: './minimal-footer.component.html',
    styleUrls: ['./minimal-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MinimalFooterComponent {
  protected reBaseData = ReBaseData;

  constructor(
    private trackingService: TrackingService
  ) { }

  getA11yLink(): string {
    return `${ReBaseData.hrefA11y}&report=${encodeURIComponent(window.location.href)}`;
  }

  trackIt(destination: string) {
    this.trackingService.postSimpleTracking(TRACKING.LOCATION.FOOTER, TRACKING.ACTION.GOTO + destination);
  }

  editCookies() {
    this.trackingService.openConsent();
    this.trackingService.postTracking(TRACKING.LOCATION.FOOTER, TRACKING.ACTION.OPEN, TRACKING.LOCATION.COOKIEBAR);
  }

}
